import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	background-color: #f5f5f5;
	padding: 30px 0;
`;

export const Container = styled.div`
	background-color: #23376c;
	width: 70%;
	margin: 0 auto;
	border-radius: 15px;
	color: #fff;
	height: auto;
	padding-bottom: 15px;
	@media screen and (max-width: 1000px) {
		width: 95%;
	}
	@media screen and (max-width: 500px) {
		width: 100%;
		border-radius: 5px;
	}
`;

export const TopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-flow: column nowrap;
	height: 140px;
	p {
		margin: 0;
		line-height: 1.2;
	}
	& > p:nth-child(1) {
		font-family: Montserrant-Bold;
		font-size: 22px;
		padding: 0 16px;
		text-align: center;
	}
	& > p:nth-child(2) {
		font-size: 13px;
		color: #dfdfdf !important;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	justify-content: center;
	height: auto;
	@media screen and (max-width: 1000px) {
		flex-flow: column nowrap;
	}
`;

export const BottomLeft = styled.div`
	flex: 1;
	margin-left: 15px;
	background-color: #1f3261;
	border-radius: 15px 0 0 15px;
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-end;
	padding-right: 40px;
	padding-top: 40px;
	padding-bottom: 40px;
	& > div {
		width: 65%;
	}
	@media screen and (max-width: 1000px) {
		margin: 0;
		align-items: center;
	}
	@media screen and (max-width: 700px) {
		& > div {
			width: 90%;
		}
	}
`;

export const BottomRight = styled.div`
	flex: 1;
	margin-right: 15px;
	background-color: #1d2c57;
	border-radius: 0 15px 15px 0;
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
	padding-left: 40px;
	padding-top: 40px;
	padding-bottom: 40px;
	& > div {
		width: 65%;
	}
	@media screen and (max-width: 1000px) {
		margin: 0;
		border-radius: 0;
		padding-left: 0;
		align-items: center;
	}
	@media screen and (max-width: 700px) {
		& > div {
			width: 90%;
		}
	}
`;

export const TopFont = styled.p`
	font-family: Montserrant-Black;
`;

export const SmallFont = styled.p`
	color: #ccc;
	line-height: 1.3;
	font-size: 13px;
	a {
		color: #ccc;
	}
`;

export const BigFont = styled.p<{ borderColor: string }>`
	border-bottom: 3px solid ${({ borderColor }) => borderColor};
	margin: 18px 0;
	font-size: 20px;
	color: #e7e7e7;
	span {
		font-family: Montserrant-Black;
		color: #fff;
	}
`;
